import * as Sentry from '@sentry/browser';
export const initSentry = () => {
    if (process.env.NODE_ENV !== 'production')
        return;
    Sentry.init({
        dsn: 'https://fbb8d34dd0e94071a2a8624a5f9746ee@o656283.ingest.sentry.io/6080454',
        environment: process.env.NODE_ENV,
        debug: true,
    });
};
export const setUser = (user) => {
    if (process.env.NODE_ENV !== 'production')
        return;
    Sentry.setUser(user);
};
